export const CASE_TYPES = [
  { value: 'asilo_en_corte', label: 'Asilo en Corte', area: 'eoir' },
  { value: 'asilo_en_uscis', label: 'Asilo ante USCIS', area: 'uscis' },
  { value: 'visa_u', label: 'Visa U', area: 'uscis' },
  { value: 'visa_t', label: 'Visa T', area: 'uscis' },
  { value: 'vawa', label: 'VAWA', area: 'uscis' },
  { value: 'estatus_juvenil_corte_familia', label: 'Estatus Juvenil — Corte de Familia', area: 'civil' },
  { value: 'estatus_juvenil_uscis', label: 'Estatus Juvenil — USCIS (SIJS)', area: 'uscis' },
  { value: 'visa_eb1', label: 'Visa EB-1', area: 'uscis' },
  { value: 'visa_eb2_niw', label: 'Visa EB-2 NIW', area: 'uscis' },
  { value: 'inversion_e2', label: 'Inversión E-2', area: 'uscis' },
  { value: 'peticion_familiar', label: 'Petición Familiar', area: 'uscis' },
  { value: 'peticion_familiar_ajuste', label: 'Petición Familiar y Ajuste de Estatus', area: 'uscis' },
  { value: 'peticion_familiar_terminacion', label: 'Petición Familiar / Terminación en Corte', area: 'eoir' },
  { value: 'apelacion_bia', label: 'Apelación BIA', area: 'eoir' },
  { value: 'apelacion_uscis', label: 'Apelación USCIS', area: 'uscis' },
  { value: 'mociones_uscis', label: 'Mociones USCIS', area: 'uscis' },
  { value: 'habeas_corpus', label: 'Habeas Corpus / Bond Hearing', area: 'civil' },
  { value: 'mandamus_federal', label: 'Mandamus — Corte Federal', area: 'civil' },
  { value: 'administrative_procedure_act_apa', label: 'Administrative Procedure Act (APA) — Corte Federal', area: 'civil' },
  { value: 'apa_mandamus', label: 'APA / Mandamus Federal (legado)', area: 'civil' },
  { value: 'trust', label: 'Fideicomiso (Trust)', area: 'civil' },
  { value: 'otro_civil', label: 'Otro caso civil federal', area: 'civil' },
  { value: 'accidente_transito', label: 'Accidente de Tránsito', area: 'accidentes' },
];
const ACRONYMS = new Map([
  ["bia", "BIA"], ["uscis", "USCIS"], ["vawa", "VAWA"], ["apa", "APA"],
  ["eb1", "EB-1"], ["eb2", "EB-2"], ["niw", "NIW"], ["e2", "E-2"],
  ["sijs", "SIJS"], ["eoir", "EOIR"],
]);

/** Human-readable label for current and legacy case values. */
export const caseTypeLabel = (type, fallback = "Tipo de caso pendiente") => {
  const value = String(type || "").trim();
  if (!value) return fallback;
  const known = CASE_TYPES.find((item) => item.value === value);
  if (known) return known.label;
  return value.replace(/[_-]+/g, " ").split(/\s+/).map((word) =>
    ACRONYMS.get(word.toLowerCase()) || `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`
  ).join(" ");
};

export const sectionForCaseType = (type) => {
  // A contract can append a custom description containing further commas.
  // Use the primary process code, not the whole description, for routing.
  const primary = String(type || '').split(/[,|]/, 1)[0].trim().toLowerCase();
  return CASE_TYPES.find((item) => item.value === primary)?.area || 'uscis';
};
